module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch00_fm09_ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_vm._v("I owe thanks to many: to students in my class on “Ethics and Political Values” at the Lyndon B. Johnson School of Public Affairs who heard stories and references to Barbara Jordan and knew that Barbara, Paul Burka (my co-teacher), and I had planned to produce an anthology for the teaching of ethics based on the courses we had taught and who, after Barbara’s death, challenged me to complete a book in honor of her; to Shinjini Kumar, our research assistant for the anthology, who located many materials that were resources for this book; to Martha Harrison for encouraging me and for locating material that was often difficult to find; to Mike Gillette for locating Jordan’s message to the National Prayer Breakfast; to Dagmar Hamilton, Nancy Earl, Diana Wienbroer, Marilyn Duncan, and various anonymous readers for reading versions of the book and for their helpful comments; to Stephen Littrell for sharing his considerable research skills; to Marvin Wofford for inviting me to speak to the Wimberley Democrats on the subject “What Would Barbara Jordan Do?”; to Joanna Hitchcock and Bill Bishel for sharing the vision of a small book on Barbara Jordan; and to the "), _c('span', {
    staticClass: "small"
  }, [_vm._v("LBJ")]), _vm._v(" School for providing so many opportunities to work with Barbara Jordan. And to Gene Alice Sherman, for encouragement and support, and for being my partner in this and every endeavor."), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c6f3183","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm09_ack.vue
// module id = 84
// module chunks = 0